import { gql } from "apollo-boost";
// import blocks from "blocks/query";
import { blogImage, link, seomatic } from 'querypieces';

export default gql`
    query($uri: String) {
        entry(uri: [$uri]) {
            ...on blog_Entry {
                articleType
                blogPostHeaderMatrix {
                  ... on blogPostHeading_Entry {
                    id
                    header
                    date
                    publisher
                    authors
                  }
                }
                blogBuilderMatrix {
                    ... on blogRichText_Entry {
                        id
                        richText
                    }
                    ... on blogImage_Entry {
                        id
                        ${blogImage}
                        altText
                        caption
                    }
                    ... on primaryCta_Entry {
                        id
                        primaryCta {
                            ${link}
                        }
                    }
                }


            }

        }
        ${seomatic}
    }
`;

